var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorNumbered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01511 22V20.5H5.51511V19.75H4.01511V18.25H5.51511V17.5H3.01511V16H6.01511C6.29844 16 6.53594 16.0958 6.72761 16.2875C6.91927 16.4792 7.01511 16.7167 7.01511 17V18C7.01511 18.2833 6.91927 18.5208 6.72761 18.7125C6.53594 18.9042 6.29844 19 6.01511 19C6.29844 19 6.53594 19.0958 6.72761 19.2875C6.91927 19.4792 7.01511 19.7167 7.01511 20V21C7.01511 21.2833 6.91927 21.5208 6.72761 21.7125C6.53594 21.9042 6.29844 22 6.01511 22H3.01511ZM3.01511 15V12.25C3.01511 11.9667 3.11094 11.7292 3.30261 11.5375C3.49427 11.3458 3.73177 11.25 4.01511 11.25H5.51511V10.5H3.01511V9H6.01511C6.29844 9 6.53594 9.09583 6.72761 9.2875C6.91927 9.47917 7.01511 9.71667 7.01511 10V11.75C7.01511 12.0333 6.91927 12.2708 6.72761 12.4625C6.53594 12.6542 6.29844 12.75 6.01511 12.75H4.51511V13.5H7.01511V15H3.01511ZM4.51511 8V3.5H3.01511V2H6.01511V8H4.51511ZM9.01511 19V17H21.0151V19H9.01511ZM9.01511 13V11H21.0151V13H9.01511ZM9.01511 7V5H21.0151V7H9.01511Z",
    fill: "#343F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorNumbered);
export default __webpack_public_path__ + "static/media/editor-numbered.bb4404afe4a613adf2d8e7b9f0e09182.svg";
export { ForwardRef as ReactComponent };